import { INotification } from "../../interfaces/INotification";

const moment = require('moment');

export const GenerateNotificationDateList = async (startDate: Date, endDate: Date, notificationData: any[]) => {

    let mergeDatas = mergeObjectsByDate(notificationData)

    const dateArray: INotification[] = [];
    for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {

        let index = mergeDatas.findIndex(i => moment(i.addedDate).format("DD MMM YYYY") == moment(date).format("DD MMM YYYY"))
        if(index == -1){
            const dateObj: INotification = {
                addedDate: new Date(date).toDateString(),
                channelID: '',
                createdDate:undefined,
                id: 0,
                muted: 0,
                unmuted: 0,
                post: 0,
                label: moment(date).format("DD MMM YYYY")
            };
            dateArray.push(dateObj);
        }else{
            let follower = {label: moment(mergeDatas[index].addedDate).format("DD MMM YYYY") ,...mergeDatas[index]} as INotification;
            dateArray.push(follower);
        }
    }
    return dateArray;
}

export const GetWeeksInRange = async (startDate: Date, endDate: Date, notificationData: any[]) => {

    let mergeDatas = mergeObjectsByDate(notificationData)
      const weekArray = [];
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const weekStart = new Date(currentDate);
        const weekEnd = new Date(new Date(currentDate).setDate(currentDate.getDate() + 6));
        const weekLabel = moment(weekStart).format("DD MMM YYYY") + ' - ' + moment(weekEnd).format("DD MMM YYYY");
        weekArray.push({ start: weekStart, end: weekEnd, label: weekLabel, muted: 0, unmuted: 0 });
        currentDate.setDate(currentDate.getDate() + 7);
      }
  
      for (let data of mergeDatas) {
        let index = weekArray.findIndex((i: any) => {
          let range = moment(data.addedDate).isBetween(i.start, i.end, null, []);
          if (range) return i;
        })
  
        if (index != -1) {
          weekArray[index].muted += data.muted == undefined ? 0 : data.muted;
          weekArray[index].unmuted += data.unmuted == undefined ? 0 : data.unmuted;
        }
  
      }
      return weekArray;
  }
  
  export const GetMonthsInRange = async (startDate: Date, endDate: Date, notificationData: any[]) => {
      
    let mergeDatas = mergeObjectsByDate(notificationData)
      const monthArray = [];
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 23, 59, 59, 999);
        const monthLabel = `${monthStart.toLocaleDateString('default', { month: 'long' })} ${monthStart.getFullYear()}`;
        monthArray.push({ start: monthStart, end: monthEnd, label: monthLabel, muted: 0, unmuted: 0  });
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
  
      for (let data of mergeDatas) {
        let index = monthArray.findIndex((i: any) => {
          let range = moment(data.addedDate).isBetween(i.start, i.end, null, []);
          if (range) return i;
        })
  
        if (index != -1) {
          monthArray[index].muted += data.muted != undefined ? data.muted : 0;
          monthArray[index].unmuted += data.unmuted != undefined? data.unmuted :0;
        }
  
      }
  
      return monthArray;
  }

function mergeObjectsByDate(arr: INotification[]): INotification[] {
    const result: INotification[] = [];
    const map: Map<string, INotification> = new Map();
  
    for (const obj of arr) {
        const dateString = obj.addedDate !== undefined ? obj.addedDate : '';
  
        if (map.has(dateString)) {
            const existingObj: any = map.get(dateString);
            existingObj!.muted += obj.muted;
            existingObj!.undefined += obj.unmuted;
        } else {
            map.set(dateString, obj);
        }
    }
  
    map.forEach((obj) => result.push(obj));
    return result;
  }